// extracted by css-extract-rspack-plugin
export default {"groupsSelectBox":"GroupsSelectBox__groupsSelectBox--xYddr"};